import { Col, Row } from 'antd'
import { Texto } from '@gravitate-js/excalibrr'
import React from 'react'
import { clamp } from '@utils/general'

export const CompartmentDetails = ({ oldCompartmentValues, newCompartmentValues }) => {
  const unitLength =
    oldCompartmentValues?.length > newCompartmentValues?.length
      ? oldCompartmentValues.length
      : newCompartmentValues.length

  const span = clamp(Math.floor(24 / unitLength), 2, 4)

  if (newCompartmentValues.length < unitLength) {
    while (newCompartmentValues.length < unitLength) {
      newCompartmentValues.push('')
    }
  } else if (oldCompartmentValues.length < unitLength) {
    while (oldCompartmentValues.length < unitLength) {
      oldCompartmentValues.push('')
    }
  }
  return (
    <div className='details-container pt-3'>
      <Row className='mb-3 mt-3 pt-4' justify='space-between'>
        {newCompartmentValues.map((compartment, index) => (
          <Col span={span} key={index}>
            <Texto align='center' appearance='secondary' weight='bold'>
              {index + 1}
            </Texto>
          </Col>
        ))}
      </Row>
      <Row className='mb-3' justify='space-between'>
        {oldCompartmentValues.map((compartment, index) => (
          <Col span={span} key={index}>
            <Texto category='label' align='center'>
              {compartment}
            </Texto>
          </Col>
        ))}
      </Row>
      <Row className='mb-3' justify='space-between'>
        {newCompartmentValues.map((compartment, index) => (
          <Col span={span} key={index}>
            <Texto
              category='label'
              align='center'
              appearance={compartment !== oldCompartmentValues[index] && 'secondary'}
              weight={compartment !== oldCompartmentValues[index] && 'bold'}
            >
              {compartment}
            </Texto>
          </Col>
        ))}
      </Row>
    </div>
  )
}
